import { createPortal } from "react-dom";
import CustomButton from "../../atoms/CustomButton";
import CloseButton from "./CloseButton";
import "./styles.scss";

const Modal = ({
  width = "450px",
  onClose,
  isActive,
  title,
  name,
  onClick,
  id,
  type = "Delete",
  description,
}) => {
  const styles = {
    width: width,
  };

  const modalJSX = (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content" style={styles}>
        <div className="modal-body type-modal-body py-4">
          <CloseButton onClose={onClose} size={20} classes={'d-flex justify-content-end'}/>

          <div className="px-3 mb-4">
          <p className="type-modal-heading mb-1 mt-2">
            {type} {title}
          </p>
          {description ?
          (
            <p className="type-modal-description">{description}</p>
          ) : (
            <p className="type-modal-descriptionn">
              Are you sure do you want delete{" "}
              <span style={{ fontWeight: 800, color: "#393939" }}>{name}</span>{" "}
              from the {title} list.
            </p>
          ) }
          </div>
       

          <div className="d-flex w-100 mt-3 flex-column gap-3">
            {/* Adjust the style for the "Confirm" button */}
            <button
              className="btn-primary mt-0 auth_btn"
              onClick={onClick}
              // style={{ flex: "1 0 45%", marginLeft: "10px" }}
            >
              {type === 'Delete' ? 'Delete' : 'Confirm' }
            </button>

            <CustomButton
              text="Cancel"
              type="btn-outline-primary"
              btn_class={"auth_btn"}
              handleClick={onClose}
              // style={{ flex: "1 0 45%" }}
              iconRequired={false}
            />
          </div>
        </div>
      </div>
    </div>
  )
  return  createPortal(modalJSX, document.getElementById('modal-root'));
};

export default Modal;
